import { addToCart, redirectToCart } from 'features/cart';
import { showAddToCartFailureModal } from 'features/cart/desktop';
import { Reporter } from 'features/dataCapture';
import { dataCaptureTimeout } from 'ui/config';

function initGiftCard() {

	let addToCartRecordId;
	const ui = {
		giftCardFirstName: document.getElementById('giftCardFirstName'),
		giftCardLastName: document.getElementById('giftCardLastName'),
		giftCardMessage: document.getElementById('giftCardMessage'),
		giftCardMsgCharTotal: document.querySelector('.jsGiftCardMsgCharTotal'),
		giftCardAmountSelector: document.getElementById('giftCardAmountSelector'),
		giftCardImage: document.getElementById('giftCardImage'),
		pdAddToCart: document.getElementById('pdAddToCart'),
		giftCardFormReveal: document.querySelector('.giftCardFormReveal'),
		giftCardSku: document.querySelector('.gift-cards__sku'),
		giftCardSkuValue: document.querySelector('.gift-cards__sku > span'),
	};

	const updateGiftCardMsgCharTotal = (e) => {

		ui.giftCardMsgCharTotal.textContent = e.target.value.length;

	};

	const updateGiftCardProductInfo = (e) => {

		const selectedGiftCardInput = e.target;

		if (selectedGiftCardInput.tagName === 'INPUT') {

			const { sku } = selectedGiftCardInput.dataset;
			ui.giftCardSku.classList.remove('hidden');
			ui.giftCardSkuValue.textContent = sku;
			ui.giftCardImage.dataset.sku = sku;
			ui.giftCardFormReveal.classList.add('reveal');

		}

	};

	const waitForDataCaptureAndRedirectToCart = () => {

		if (!window.lp.globals.enableDataCapture) {

			redirectToCart();
			return;

		}

		const { reporter } = window.lp.dataCapture;
		const pageImg = ui.giftCardImage;

		const skuViewRequest = reporter.track(Reporter.getSkuViewData(pageImg));

		const atcRecord = reporter.getRecordById(addToCartRecordId);
		const atcRequest = atcRecord.promise;

		const timeout = window.setTimeout(redirectToCart, dataCaptureTimeout);
		Promise.all([ skuViewRequest, atcRequest ]).finally(() => {

			window.clearTimeout(timeout);
			redirectToCart();

		});

	};

	const callAddToCart = (e) => {

		e.preventDefault();

		const giftCardSelector = '#giftCardForm';
		const giftCardForm = document.querySelector(giftCardSelector);
		const $giftCardForm = $(giftCardSelector);
		const giftCardFormInvalid = $giftCardForm.length > 0 && !$giftCardForm.valid();

		// Gift Card validation
		if (giftCardFormInvalid) {

			giftCardForm?.querySelector('input.error')?.focus();
			return false;

		}

		// Get the selected gift card radio button
		const selectedRadio = document.querySelector('#giftCardAmountSelector .giftCardAmountRadio:checked');

		if (selectedRadio) {

			ui.pdAddToCart.classList.add('loading', 'disabled', 'noPointerEvents');

			// Retrieve the short SKU and SKU input type from the selected radio button
			const shortSku = selectedRadio.getAttribute('data-sku');
			const skuInputType = selectedRadio.getAttribute('data-sku-input-type');
			const arrData = [{
				ShortSku: shortSku,
				Quantity: 1,
				GiftCardProductInfo: {
					Amount: Number(selectedRadio.value || 0),
					RecipientFirstName: ui.giftCardFirstName.value.trim(),
					RecipientLastName: ui.giftCardLastName.value.trim(),
					Message: ui.giftCardMessage.value.trim()
				},
				SkuInputType: skuInputType
			}];

			if (window.lp.globals.enableDataCapture) {

				const { reporter } = window.lp.dataCapture;
				reporter.trackAddToCart(arrData, ui.pdAddToCart);
				addToCartRecordId = reporter.getLastRecordId();
	
			}

			addToCart({
				arrData,
				successCallback: waitForDataCaptureAndRedirectToCart,
				errorCallback: (errors, xhr, response) => {

					showAddToCartFailureModal({
						cartStatus: errors,
						response,
						fromModal: false
					});
					ui.pdAddToCart.classList.remove('loading', 'disabled', 'noPointerEvents');

				},
				includeCartOverview: false,
				rememberLastAddedItem: true,
			});

		}
	
	};

	const initializeDataCapture = () => {

		if (!window.lp.globals.enableDataCapture) {

			return;

		}

		const { reporter } = window.lp.dataCapture;

		// Fire SkuView event for each Gift Card SKUs on PDP
		const section = 'PDPMainProduct';
		const { hasAddToCart } = document.querySelector(`[data-capture-section="${section}"]`)?.dataset || {};
		const giftCards = ui.giftCardAmountSelector.querySelectorAll('.giftCardAmountRadio');
		giftCards.forEach((gc) => {

			reporter.track(
				{
					event: 'SkuView',
					hasAddToCart,
					section,
					sku: gc.dataset.sku,
					customizedProductCombination: null,
					isOpenBox: '0',
					isRecommendedBulb: '0',
					skuInputType: gc.dataset.skuInputType
				},
				{ immediate: false }
			);

		});
		// Fire all SkuView events at once
		reporter.send();

	};

	function init () {

		const giftCardFormSelector = '#giftCardForm';

		// prevent gift card form data to be shown when pressing Back/Forward button
		document.querySelector(giftCardFormSelector).reset();

		window.initFormValidation(true, giftCardFormSelector);

		ui.pdAddToCart.addEventListener('click', callAddToCart);
		ui.giftCardMessage.addEventListener('input', updateGiftCardMsgCharTotal);
		ui.giftCardMessage.addEventListener('blur', updateGiftCardMsgCharTotal);
		ui.giftCardAmountSelector.addEventListener('click', updateGiftCardProductInfo);

		initializeDataCapture();

	}

	return Object.freeze({ init });

}

export default initGiftCard;
